var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import * as React from "react";
import { useContext, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import LikertScale from "likert-react";
import { CircularProgress, TextField, Typography } from "@material-ui/core";
import MarkdownText from "../MarkdownText";
import PeerReviewOption from "./PeerReviewOption";
import * as peerReviewsActions from "../../state/peerReviews/actions";
import { useTypedSelector } from "../../state/store";
import { scrollToRef } from "../../utils";
import { BoldTypography, BoldTypographyMedium, SpaciousTypography, TopMarginDivLarge, withMargin } from "../styleComponents";
import styled from "styled-components";
import SelectButton from "./SelectButton";
import SpamButton from "./SpamButton";
import PeerReviewSubmitButton from "./PeerReviewSubmitButton";
import ThemeProviderContext from "../../contexes/themeProviderContext";
var ButtonWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  margin: 1rem 0 2rem;\n  margin-top: 0;\n  button:last-of-type {\n    margin-left: auto;\n  }\n  ", "\n"], ["\n  display: flex;\n  margin: 1rem 0 2rem;\n  margin-top: 0;\n  button:last-of-type {\n    margin-left: auto;\n  }\n  ", "\n"])), function (_a) {
  var providedStyles = _a.providedStyles;
  return providedStyles;
});
var Loading = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 2rem 0 0 1rem;\n  p {\n    margin-top: 1rem;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 2rem 0 0 1rem;\n  p {\n    margin-top: 1rem;\n  }\n"])));
var Form = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var providedStyles = _a.providedStyles;
  return providedStyles;
});
var QuestionBlockWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var providedStyles = _a.providedStyles;
  return providedStyles;
});

var PeerReviewForm = function PeerReviewForm(_a) {
  var languageInfo = _a.languageInfo,
      instructionStartRef = _a.instructionStartRef;
  var themeProvider = useContext(ThemeProviderContext);
  var focusRef = useRef(null);
  var answersToReview = useTypedSelector(function (state) {
    return state.peerReviews.options;
  });
  var peerReview = useTypedSelector(function (state) {
    return state.peerReviews.answer;
  });
  var error = useTypedSelector(function (state) {
    return state.message.error;
  });
  var dispatch = useDispatch();
  console.log(peerReview);
  useEffect(function () {
    focusRef.current && focusRef.current.focus();
  }, [Boolean(peerReview)]);

  var unselectAnswer = function unselectAnswer() {
    dispatch(peerReviewsActions.unselectAnswer());
    scrollToRef(instructionStartRef);
  };

  if (!answersToReview) {
    return React.createElement(Loading, null, error ? React.createElement("div", null) : React.createElement(React.Fragment, null, React.createElement(CircularProgress, {
      size: 25
    }), React.createElement(Typography, null, languageInfo.loadingLabel)));
  }

  if (answersToReview.length === 0) {
    return React.createElement(Typography, null, languageInfo.noPeerAnswersAvailableLabel);
  }

  var Instructions = withMargin(BoldTypographyMedium, "2rem 0 0");
  var OptionTypography = withMargin(BoldTypography, "0 0 1rem");

  if (peerReview) {
    var chosenAnswer = answersToReview.find(function (a) {
      return a.id === peerReview.quizAnswerId;
    });

    if (!chosenAnswer) {
      return React.createElement("div", null, "Chosen answer id doesn't belong to any of the options");
    }

    return React.createElement(Form, {
      providedStyles: themeProvider.peerReviewFormStyles
    }, React.createElement(Instructions, {
      ref: focusRef,
      tabIndex: -1
    }, languageInfo.chosenEssayInstruction), React.createElement(TopMarginDivLarge, null, React.createElement(PeerReviewOption, {
      answer: chosenAnswer
    }), React.createElement(ButtonWrapper, {
      providedStyles: themeProvider.buttonWrapperStyles
    }, React.createElement(SelectButton, {
      onClick: unselectAnswer
    }, languageInfo.unselectButtonLabel)), React.createElement(PeerReviewQuestions, {
      peerReview: peerReview,
      languageInfo: languageInfo,
      scrollRef: instructionStartRef
    })));
  }

  return React.createElement(Form, {
    providedStyles: themeProvider.peerReviewFormStyles
  }, React.createElement(TopMarginDivLarge, null, React.createElement(BoldTypographyMedium, {
    ref: focusRef,
    tabIndex: -1
  }, languageInfo.chooseEssayInstruction)), answersToReview.map(function (answer, idx) {
    return React.createElement(TopMarginDivLarge, {
      key: answer.id
    }, React.createElement(OptionTypography, {
      component: "p",
      variant: "subtitle1"
    }, languageInfo.optionLabel + " " + (idx + 1) + ":"), React.createElement(PeerReviewOption, {
      answer: answer
    }), React.createElement(ReportOrSelect, {
      answer: answer,
      languageInfo: languageInfo,
      scrollRef: instructionStartRef
    }));
  }));
};

var PeerReviewQuestions = function PeerReviewQuestions(_a) {
  var peerReview = _a.peerReview,
      languageInfo = _a.languageInfo,
      scrollRef = _a.scrollRef;
  var themeProvider = useContext(ThemeProviderContext);
  var quiz = useTypedSelector(function (state) {
    return state.quiz;
  });
  var submitDisabled = useTypedSelector(function (state) {
    return state.peerReviews.submitDisabled;
  });
  var error = useTypedSelector(function (state) {
    return state.message.error;
  });
  var dispatch = useDispatch();
  var languages = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });
  var HiddenLikertDescription = styled.p(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    position: absolute;\n    left: -10000px;\n  "], ["\n    position: absolute;\n    left: -10000px;\n  "])));

  if (!quiz) {
    return React.createElement("div", null);
  }

  var peerReviewQuestions = quiz.peerReviewCollections;

  var changeInPeerReviewGrade = function changeInPeerReviewGrade(peerReviewQuestionId) {
    return function (name, value) {
      dispatch(peerReviewsActions.changeGrade(peerReviewQuestionId, Number(value)));
    };
  };

  var changeInPeerReviewText = function changeInPeerReviewText(peerReviewQuestionId) {
    return function (e) {
      dispatch(peerReviewsActions.changeText(peerReviewQuestionId, e.currentTarget.value));
    };
  };

  var submitPeerReview = function submitPeerReview() {
    dispatch(peerReviewsActions.submit());
    scrollToRef(scrollRef);
  };

  var questions = peerReviewQuestions[0].questions;
  var blocks = [];
  var block = [];

  for (var i = 0; i < questions.length; i++) {
    if (questions[i].type === "essay") {
      block.length > 0 && blocks.push(block);
      block = [];
    }

    block.push(questions[i]);

    if (i === questions.length - 1) {
      blocks.push(block);
    }
  }

  return React.createElement("div", null, blocks.map(function (block) {
    return React.createElement(QuestionBlockWrapper, {
      providedStyles: themeProvider.questionBlockWrapperStyles,
      role: "group",
      "aria-label": languages && languages.peerReviews.peerReviewGroupTitle || "",
      "aria-describedby": "peer-review-info"
    }, React.createElement(HiddenLikertDescription, {
      id: "peer-review-info"
    }, languages && languages.peerReviews.peerReviewLikertDetails), block.map(function (question) {
      var currentPeerReviewAnswer = peerReview.answers.find(function (answer) {
        return answer.peerReviewQuestionId === question.id;
      });

      if (!currentPeerReviewAnswer) {
        return React.createElement("div", null);
      }

      switch (question.type) {
        case "essay":
          currentPeerReviewAnswer = currentPeerReviewAnswer;
          return React.createElement(TextualPeerReviewFeedback, {
            handleTextChange: changeInPeerReviewText(question.id),
            key: question.id,
            currentText: currentPeerReviewAnswer.text,
            questionTexts: question
          });
          break;

        case "grade":
          currentPeerReviewAnswer = currentPeerReviewAnswer;
          return React.createElement(LikertScale, {
            key: question.id,
            separatorType: themeProvider.likertSeparatorType || "dotted-line",
            reviews: [{
              question: question.title,
              review: currentPeerReviewAnswer.value
            }],
            onClick: changeInPeerReviewGrade(question.id)
          });

        default:
          return React.createElement(SpaciousTypography, null, "The " + question.type + " type peer review question is not supported");
      }
    }));
  }), React.createElement("div", null), React.createElement(PeerReviewSubmitButton, {
    disabled: submitDisabled || error,
    onClick: submitPeerReview
  }, languageInfo.submitPeerReviewLabel));
};

var StyledReviewEssayQuestion = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin: 8px 0;\n"], ["\n  margin: 8px 0;\n"])));

var TextualPeerReviewFeedback = function TextualPeerReviewFeedback(_a) {
  var currentText = _a.currentText,
      handleTextChange = _a.handleTextChange,
      questionTexts = _a.questionTexts;
  var languages = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });

  if (!languages) {
    return React.createElement("div", null);
  }

  return React.createElement(StyledReviewEssayQuestion, null, React.createElement(MarkdownText, {
    Component: BoldTypographyMedium,
    variant: "subtitle1",
    variantMapping: {
      subtitle1: "p"
    }
  }, questionTexts.title), questionTexts.body && React.createElement(MarkdownText, {
    Component: Typography,
    variant: "body1"
  }, questionTexts.body), React.createElement(TextField, {
    variant: "outlined",
    label: languages.peerReviews.essayQuestionAnswerTextBoxLabel,
    value: currentText,
    onChange: handleTextChange,
    fullWidth: true,
    multiline: true,
    rows: 5,
    margin: "normal"
  }));
};

var ReportOrSelect = function ReportOrSelect(_a) {
  var languageInfo = _a.languageInfo,
      answer = _a.answer,
      scrollRef = _a.scrollRef;
  var themeProvider = useContext(ThemeProviderContext);
  var error = useTypedSelector(function (state) {
    return state.message.error;
  });

  var _b = React.useState(false),
      disabled = _b[0],
      setDisabled = _b[1];

  var dispatch = useDispatch();

  var flagAsSpam = function flagAsSpam() {
    setDisabled(true);
    dispatch(peerReviewsActions.postSpam(answer.id));
    scrollToRef(scrollRef);
  };

  var selectAnswer = function selectAnswer() {
    dispatch(peerReviewsActions.selectAnswerToReview(answer.id));
    scrollToRef(scrollRef);
  };

  return React.createElement(ButtonWrapper, {
    providedStyles: themeProvider.buttonWrapperStyles
  }, React.createElement(SpamButton, {
    disabled: disabled || error,
    onClick: flagAsSpam
  }, languageInfo.reportAsInappropriateLabel), React.createElement(SelectButton, {
    onClick: selectAnswer
  }, languageInfo.chooseButtonLabel));
};

export default PeerReviewForm;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;